import DonutProgressChartViz from '../vizs/DonutProgressChartViz'
import BaseComponent from './BaseComponent'
/**
 * {-EN-}
 * # {componentLabel} (`class {componentClassName}`)
 *
 * A donut progress chart is a circular representation of an actual performance in comparision with a predetermined schedule.
 *
 * ### Example Usage
 * ```javascript
 *
 *   import {DonutProgressChart} from 'sdv-lib'
 *
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new DonutProgressChart($el, data, config);
 * ```
 *
 * This class is only intended to draw simple Donut progress charts. For regular [Donut Progress Chart](#/developer/DonutProgressChartComponent)s see the corresponding documentation.
 *
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 3 columns. Each row represents a layer: the first column should be the category id/label, the second column its value and the third column its total expected value.
 *
 * | category | value  | total  |
 * | -------- | ------ | ------ |
 * |   a      |    22.4|     100|
 * |   b      |    52.3|      60|
 *
 * {.data-table}
 * 
 * {-ES-}
 * # {componentLabelEs} (`class {componentClassName}`)
 *
 * Un gráfico de progreso de donut es una representación circular de un desempeño real en comparación con un cronograma predeterminado.
 *
 * ### Ejemplo de uso
 * ```javascript
 *
 *   import {DonutProgressChart} from 'sdv-lib'
 *
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new DonutProgressChart($el, data, config);
 * ```
 *
 * Esta clase solo está destinada a dibujar gráficos simples de progreso de Donut. Para uso regular [Gráfico de progreso en donut](#/developer/DonutProgressChartComponent) ver la documentación correspondiente.
 *
 * ### Estructura de datos {.section-data-structure}
 * Los datos tabulares de este gráfico deben ser una tabla con 3 columnas. Cada fila representa una capa: la primera columna debe ser la identificación/etiqueta de la categoría, la segunda columna su valor y la tercera columna su valor total esperado.
 *
 * | categoría | valor  | total  |
 * | -------- | ------ | ------ |
 * |   a      |    22.4|     100|
 * |   b      |    52.3|      60|
 *
 * {.data-table}
 * */
export default class DonutProgressChartComponent extends BaseComponent {
  static vizClass = DonutProgressChartViz
  static componentLabel = 'Donut progress chart'
  static componentLabelEs = "Gráfico de progreso en donut"
  static dataFormat = [
    { index: 0, axis: '', types: [String], role: 'id', roleLabel: 'Category' },
    { index: 1, axis: '', types: [Number], role: 'value', roleLabel: 'Value' },
    { index: 2, axis: '', types: [Number], role: 'total', roleLabel: 'Total' },
  ]
  static defaultConfig = {
    title: this.componentLabel,
    mode: 'donut',
    donutThickness: {
      nonEditable: true,
    },
    TooltipBehavior: {
      tooltipValueFormat: {
        exposed: true,
        nonEditable: false,
      },
    },
  }
}
